export const environment = {
  production: true,
  baseUrl: "https://software.group-activa.com:44305/activa_server",
  idleBaseUrl: "https://software.group-activa.com:44305/notify",
  faceUrl: "https://activaapimanagement.azure-api.net/facial/",
  autoService: "https://sh-ci-staging-costapp.azurewebsites.net/#/",
  riskService:
    "https://software.group-activa.com:44305/costapps/#/multirisque-habitation-step1/",
  condoleanceService:
    "https://software.group-activa.com:44305/costapps/#/condoleance-stepOne/",
  ladyStartupService:
    "https://software.group-activa.com:44305/costapps/#/ladyStartUp-step1/",
  chatbotService: "https://activa-chatbot.sevengps.net/full/#/seven/load",
  getInsurrance:
    "https://software.group-activa.com:44305/costapps/#/all-assurance/",
  googleTrackingId: "UA-199007566-1",
  loginUrl: "https://asurecover-backend-gui-prod.azurewebsites.net",
  automobileBaseUrl:
    "https://activaapimanagementprod.azure-api.net/tarifiktor-prod-gui",
  subscriptionBaseUrl:
    "https://activaapimanagementprod.azure-api.net/souscription-prod-gui",
  printingBaseUrl:
    "https://activaapimanagementprod.azure-api.net/docgenerator-prod-gui",
  automobileExtraBaseUrl:
    "https://asurecover-backend-gui-prod.azurewebsites.net",
  assureBaseUrl:
    "https://activaapimanagementprod.azure-api.net/activaorassapiprod",
  assureAuthApiUser: "GUI-SH",
  autoAuthApiUser: "GUI-SH",
  assureAuthApiPassword: "14cf85274653932df6d68e0acbaf1193",
  autoAuthApiPassword: "2e3efd364a359a093f1b421ee898fc27",
  identProcess: "GUI-SH",
  ocpApimSubscriptionKey: "807f4890563747e797465aa99323b54a",
  api_tarification: "https://apimanagementguineebankassurances.azure-api.net/bank",
  tokenBankAssurance: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiI1IiwidW5pcXVlX25hbWUiOiJBY2NvdW50TWFuYWdlciIsInJvbGUiOiJBY2NvdW50TWFuYWdlciIsIm5iZiI6MTc0MjIxNDUyNSwiZXhwIjoxNzQyODE5MzI1LCJpYXQiOjE3NDIyMTQ1MjV9.m558jeVsmAkiJZnqVIWakOAuKeJ6z9SPgj4Dv_zr5ek",
  tokem_bank: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIzIiwidW5pcXVlX25hbWUiOiJNYW5hZ2VyIFVzZXIiLCJFbWFpbCI6Im1hbmFnZXJAYmFuay5jb20iLCJCYW5rSWQiOiIxIiwicm9sZSI6Ik1hbmFnZXIiLCJDb21wYW55Q29kZXMiOiJbXCJDb21wYW55Q29kZUFcIl0iLCJuYmYiOjE3NDM1ODcxNzAsImV4cCI6MTc0NDE5MTk3MCwiaWF0IjoxNzQzNTg3MTcwfQ.09LGSWAr-8wjsnQ_pixd9cH7g1VCqMFVgLYrhvROzHg",
  tokem_bankAssurance: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiI1IiwidW5pcXVlX25hbWUiOiJBY2NvdW50TWFuYWdlciIsInJvbGUiOiJBY2NvdW50TWFuYWdlciIsIm5iZiI6MTc0MjIxNDUyNSwiZXhwIjoxNzQyODE5MzI1LCJpYXQiOjE3NDIyMTQ1MjV9.m558jeVsmAkiJZnqVIWakOAuKeJ6z9SPgj4Dv_zr5ek",
  MSBank: "https://apimanagementguineebankassurances.azure-api.net/bank",
  MSAggravation: "https://apimanagementguineebankassurances.azure-api.net/agravation",
  MSPolicy: "https://apimanagementguineebankassurances.azure-api.net/bankAssurancePolice",
  MSHeliosCore: "https://bancassurance-helioscore-gui-test.group-activa.com",
  bancassurance_api_username: "AssureCoverUser",
  bancassurance_api_password: "rp9KcYD6.vvnWMCtPkGK;6u#Tm4<9",
  Ocp_Apim_Subscription_Key: "fbffc547d56b43008610911f7846bc7c",
  MsUpload: "https://apimanagementguineebankassurances.azure-api.net/msedition",
  heliosCore_login: "elie",
  heliosCore_password: "af91b1c58ffd63b624ce9cb8428e60f2",
  heliosCore_language: "fr-FR",
  heliosCore_id: -9999,
  // Propriétés manquantes — valeurs copiées depuis environment.ts
  evoGrantType: "client_credentials",
  evoScope: "urn:axa.partners.sales.individual.travel.quotesrequests.write urn:axa.partners.sales.individual.travel.policies.write",
  evoApiUser: "APICAMEROUN@ACTIVA",
  evoApiPassword: "ACTIVA_CAMEROUN",
  evoBaseUrl: "https://agent-distribution-channel.com/api/v1/index.php",
  backassuranceLocal: "https://localhost:44386"
};
